import axios from "axios"
import LayoutError from "components/LayoutError"
import { IErrorResponse } from "models/errors"
import React, { ReactNode, ErrorInfo } from "react"
import { RequirePermission } from "components/RequirePermission"
import { EOpusPermission } from "contexts/authorization/hooks/use-opus-permissions"

interface IClientsProps {
  children: ReactNode
}

interface IClientsBoundaryState {
  hasError: boolean
  error?: Error
  errorInfo?: ErrorInfo
}

export class ClientsBoundary extends React.Component<
  IClientsProps,
  IClientsBoundaryState
> {
  constructor(props: IClientsProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): IClientsBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    this.setState({ hasError: true, errorInfo, error })
  }

  render(): ReactNode {
    if (this.state.hasError) {
      if (axios.isAxiosError(this.state.error)) {
        const error = this.state.error as IErrorResponse

        return (
          <LayoutError
            title="Sorry, something went wrong."
            subTitle="Please contact support quoting the request ID below."
            requestID={error.response.data.requestID}
          />
        )
      } else {
        return (
          <LayoutError
            title="Sorry, something went wrong."
            subTitle="Please contact support if this error continues."
          />
        )
      }
    }

    return (
      <RequirePermission
        permissions={[
          `${EOpusPermission.aventusadmin}:true`,
          `${EOpusPermission.ClientManagement}:true`
        ]}
      >
        {this.props.children}
      </RequirePermission>
    )
  }
}
